import { IconSwords, IconShieldCheck, IconTrophy } from '../../components/icons.jsx';
import { ma } from './ArenaMedia.jsx';
import { MATCH_INTRO_MS } from './hand-gesture.js';
import './ArenaBattleIntro.css';

function IntroPlayer({ side, enemy = false }) {
  const Icon = enemy ? IconSwords : IconShieldCheck;
  return <div className={`battle-intro-player${enemy ? ' battle-intro-opponent' : ''}`}>
    <span className="battle-intro-avatar" aria-hidden="true"><Icon /></span>
    <div className="battle-intro-identity"><small>{enemy ? 'Соперник' : 'Вы'}</small><b title={side.name}>{side.name}</b></div>
    <span className="battle-intro-rating" aria-label={`Рейтинг ${ma(side.rating)}`}><IconTrophy aria-hidden="true" />{ma(side.rating)}</span>
  </div>;
}

export function ArenaBattleIntro({ me, opponent }) {
  return <div className="battle-match-intro" role="status" aria-label="Участники боя" style={{ '--intro-duration': `${MATCH_INTRO_MS}ms` }}>
    <div className="battle-intro-art" aria-hidden="true">
      <img src="/arena-matchmaking-halloween.webp" alt="" width="1254" height="1254" />
      <div className="battle-intro-embers"><i /><i /><i /><i /></div>
    </div>
    <span className="battle-intro-season">HALLOWEEN</span>
    <div className="battle-intro-lineup">
      <IntroPlayer side={opponent} enemy />
      <div className="battle-intro-versus"><span /><strong>VS</strong><span /></div>
      <IntroPlayer side={me} />
    </div>
    <div className="battle-intro-countdown"><p>Бой начинается</p><span aria-hidden="true"><i /></span></div>
  </div>;
}
